var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5865F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4044 9.39583C22.0234 8.74375 20.5469 8.26985 19.0031 8C18.8136 8.34593 18.5921 8.81122 18.4393 9.18135C16.7983 8.93228 15.1724 8.93228 13.5616 9.18135C13.4089 8.81122 13.1824 8.34593 12.9911 8C11.4457 8.26985 9.96746 8.74549 8.58651 9.39928C5.80113 13.6472 5.04606 17.7897 5.4236 21.8733C7.27101 23.2657 9.06137 24.1115 10.8215 24.665C11.2561 24.0613 11.6437 23.4196 11.9776 22.7433C11.3417 22.4995 10.7326 22.1985 10.1571 21.8491C10.3098 21.735 10.4591 21.6156 10.6034 21.4928C14.1136 23.1498 17.9276 23.1498 21.3959 21.4928C21.5419 21.6156 21.6912 21.735 21.8422 21.8491C21.265 22.2002 20.6542 22.5012 20.0183 22.7451C20.3522 23.4196 20.7381 24.0631 21.1744 24.6667C22.9362 24.1132 24.7283 23.2674 26.5757 21.8733C27.0187 17.1394 25.8189 13.035 23.4044 9.39583ZM12.4558 19.3619C11.4021 19.3619 10.5379 18.3691 10.5379 17.1601C10.5379 15.9511 11.3836 14.9566 12.4558 14.9566C13.5281 14.9566 14.3922 15.9494 14.3737 17.1601C14.3754 18.3691 13.5281 19.3619 12.4558 19.3619ZM17.6256 17.1601C17.6256 18.3691 18.4897 19.3619 19.5434 19.3619C20.6156 19.3619 21.4613 18.3691 21.4613 17.1601C21.4798 15.9494 20.6156 14.9566 19.5434 14.9566C18.4712 14.9566 17.6256 15.9511 17.6256 17.1601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discord-icon.06a574b46d446ee934fe2d0630f4bb10.svg";
export { ForwardRef as ReactComponent };